import axios from 'axios';

export class SendAvailableDetailService {
    /**
     * Función que consulta el back para obtener la información
     * que se muesta en la pantalla "Enviar Disponible".
     * @param emisoraStr String con el cual se busca
     *                   Si viene vacío trae todos los datos
     * @returns {Promise<unknown>} Lista con la información a mostrar.
     */
    getInstitutionAvailablePTM() {
        return axios.get('/appapv/getInstitutionAvailablePTM.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    sendMailAvailablePTM(emailList, emailStr) {
        return axios.post('/appapv/sendMailAvailablePTM.action', {}, {
            params: {
                listFilterJson: JSON.stringify(emailList),
                correo: emailStr,
            }
        }).then(res => res.data);
    }

}